import { Injectable } from '@angular/core';

import { ApiService } from '@app/_services/api.service';
import { CommomHeaders } from '@app/_shared/httpHeaders/CommonHeaders';

@Injectable({
    providedIn: 'root',
})
export class AfipService {
    constructor(private api: ApiService, private headers: CommomHeaders) {}

    save960Form(data: { html: string }) {
        return this.api.put(`/api/v1/back/config/data-fiscal`, data, this.headers.getAuthHeaders());
    }

    get960FormData() {
        return this.api.get(`/api/v1/back/config/data-fiscal`, this.headers.getAuthHeaders());
    }
}
